import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useI18n, getLocale, pendingInterval } from "./i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const get = (path, params) => axios.get(`${API}${path}`, { params }).then((r) => r.data);
export const useLangQuery = (key, path, params = {}) => {
  const { lang } = useI18n();
  return useQuery({ queryKey: [...key, lang], queryFn: () => get(path, { ...params, lang }), refetchInterval: pendingInterval, placeholderData: (prev) => prev });
};

export const useConfig = () => useQuery({ queryKey: ["config"], queryFn: () => get("/config"), staleTime: Infinity });
export const useProducts = (params = {}) => useLangQuery(["products", params], "/products", params);
export const useProduct = (handle) => useLangQuery(["product", handle], `/products/${handle}`);
export const useCollections = () => useQuery({ queryKey: ["collections"], queryFn: () => get("/collections") });
export const useBlog = () => useLangQuery(["blog"], "/blog");
export const useArticle = (handle) => useLangQuery(["article", handle], `/blog/${handle}`);

export const subscribe = (email, source) => axios.post(`${API}/subscribe`, { email, source }).then((r) => r.data);
export const createCheckout = (items, discount_code, extras = {}) =>
  axios.post(`${API}/checkout`, { items, discount_code, ...extras }).then((r) => r.data.checkout_url);

export const money = (v) => {
  try { return new Intl.NumberFormat(getLocale(), { style: "currency", currency: "EUR" }).format(v || 0); }
  catch { return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(v || 0); }
};
export const discountPct = (p) => (p.compare_at_price && p.compare_at_price > p.price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0);
export const cleanTitle = (t = "") => t.replace(/\s+(BELLECARE|PRIMUS)$/i, "").replace(/\s*[-–]\s*$/, "").replace(/\bBELLECARE\b/g, "Bellecare");
